import React, { useState } from "react";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { displayBalance, displayBalanceFloat, displayNDC } from "../../utils/Helpers";

// positive first, negative second, zero third
const sortTier = (num) => (num > 0 ? 1 : num < 0 ? 2 : 3);

const ndcSort = (a, b) => {
  if (sortTier(b.outstanding_purchase_count) !== sortTier(a.outstanding_purchase_count)) {
    return sortTier(a.outstanding_purchase_count) - sortTier(b.outstanding_purchase_count);
  }

  if (b.outstanding_purchase_count !== a.outstanding_purchase_count) {
    return b.outstanding_purchase_count - a.outstanding_purchase_count;
  }

  if (b.purchase_unit_balance !== a.purchase_unit_balance) {
    return b.purchase_unit_balance - a.purchase_unit_balance;
  }

  if (b.claim_unit_balance !== a.claim_unit_balance) {
    return b.claim_unit_balance - a.claim_unit_balance;
  }

  return String(a.ndc).localeCompare(String(b.ndc), undefined, { numeric: true });
};

export const ProductPurchaseRow = ({ purchase }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <div
        className={`row align-items-center bg--white row-border-bottom h--48 ${expanded ? "bg--light-navy" : ""}`}
        key={purchase.id}
      >
        <div className="col col-1">
          <button className="btn btn--sqr" onClick={() => setExpanded(!expanded)}>
            {expanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
          </button>
        </div>
        <div className="col col-4 t--500">{purchase.product_name}</div>
        <div className="col col-2">{displayBalance(purchase.outstanding_purchase_count)}</div>
        <div className="col col-3">{displayBalanceFloat(purchase.purchase_unit_balance)}</div>
        <div className="col col-2">{displayBalanceFloat(purchase.claim_unit_balance)}</div>
      </div>
      {expanded ? (
        <div>
          {purchase.ndcs.sort(ndcSort).map((ndc) => (
            <div
              className="row align-items-center border--bottom"
              style={{ height: 38 }}
              key={ndc.ndc}
            >
              <div className="col col-1"></div>
              <div className="col col-4 t--500">{displayNDC(ndc.ndc ?? "")}</div>
              <div className="col col-2">{displayBalance(ndc.outstanding_purchase_count)}</div>
              <div className="col col-3">{displayBalanceFloat(ndc.purchase_unit_balance)}</div>
              <div className="col col-2">{displayBalanceFloat(ndc.claim_unit_balance)}</div>
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};
